import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { INoteModel } from '@apps-common/types/management/note'

export const createNote = async (model: INoteModel): Promise<INoteModel> =>
  axios.post(`/management/note/addnote`, model).then((res) => res?.data?.data)

type Props = {
  model: INoteModel
}

export const useManagementCreateNote = (notify?: boolean, onSuccess?: (data: INoteModel) => void) =>
  useMutation({
    mutationKey: ['createContact'],
    mutationFn: ({ model }: Props) => createNote(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created note.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create note, please try again.')
      }
    },
    throwOnError: false
  })
